// extracted by mini-css-extract-plugin
export default {"wrapper":"r2-z","play":"s2-z"};